import styled from 'styled-components'
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  ColorProps,
  compose,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  ResponsiveValue,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  system as styledSystem,
  textAlign,
  TextAlignProps,
  typography,
} from 'styled-system'

type GapValue = string | number

export interface GapProps {
  gap?: ResponsiveValue<GapValue>
  rowGap?: ResponsiveValue<GapValue>
  columnGap?: ResponsiveValue<GapValue>
}

export type BoxProps = FlexboxProps &
  SpaceProps &
  LayoutProps &
  BorderProps &
  PositionProps &
  ShadowProps &
  TextAlignProps &
  ColorProps &
  BackgroundProps &
  GapProps & {
    interactive?: boolean
    hide?: boolean
  }

const gapSystem = styledSystem({
  gap: {
    property: 'gap',
    scale: 'space',
  },
  rowGap: {
    property: 'rowGap',
    scale: 'space',
  },
  columnGap: {
    property: 'columnGap',
    scale: 'space',
  },
})

const system = compose(
  border,
  color,
  flexbox,
  layout,
  position,
  space,
  shadow,
  typography,
  textAlign,
  background,
  gapSystem
)

export const Box = styled.div<BoxProps>(
  ({ interactive }) => ({
    boxSizing: 'border-box',
    flexShrink: 0, // this is for Safari
    cursor: interactive ? 'pointer' : undefined,
  }),
  system
)

export const FlexBox = styled(Box)({ display: 'flex' })
